import { render, staticRenderFns } from "./CurveData.vue?vue&type=template&id=16280239&scoped=true"
import script from "./CurveData.vue?vue&type=script&lang=js"
export * from "./CurveData.vue?vue&type=script&lang=js"
import style0 from "./CurveData.vue?vue&type=style&index=0&id=16280239&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16280239",
  null
  
)

export default component.exports